// extracted by mini-css-extract-plugin
export var divider = "_em-7";
export var itemsToggle = "_em-8";
export var mergeModal = "_em-1";
export var optionCard = "_em-4";
export var radioGroup = "_em-6";
export var radioOption = "_em-0";
export var selected = "_em-5";
export var shipmentOptions = "_em-2";
export var tableOptions = "_em-3";